import Backbone from 'backbone';
import _ from 'underscore';

function capitalize(str: $TSFixMe) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const YesNoSchema = Backbone.Model.extend({
  defaults() {
    return {
      prompt: '',
    };
  },

  getChoicePoints(choice: $TSFixMe) {
    if (this.get('points')) {
      if (choice === 'Yes') {
        return this.get('points').yes;
      } else if (choice === 'No') {
        return this.get('points').no;
      }
    }

    return undefined;
  },

  getMaxScore() {
    return Math.max(..._(this.get('points')).values());
  },

  /**
   * Like getChoiceBestRepresentingReviews, but only works for scored parts. The sidebar review view uses this.
   * TODO(marc): Remove this when we remove the sidebar review view.
   */
  getOption(points: $TSFixMe) {
    const pair = _(this.get('points'))
      .chain()
      .pairs()
      .filter(function (pair) {
        return pair[1] <= points;
      })
      .sortBy(_.property(1))
      .last()
      .value();

    return {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      display: capitalize(pair[0]),
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      points: pair[1],
    };
  },

  /**
   * Does the same thing as options/models/schema for Yes/No options.
   */
  getChoiceBestRepresentingReviews(reviewChoices: $TSFixMe, score: $TSFixMe) {
    if (reviewChoices.length === 0) {
      return null;
    }

    const counts = _(reviewChoices).countBy(_.identity);

    if ((counts.Yes || 0) > (counts.No || 0)) {
      return 'Yes';
    } else {
      return 'No';
    }
  },
});

export default YesNoSchema;
